<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'DHCP Option82 Interface Config'" style="height: 430px">
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>
        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAll"
                />
                <label for="idSelectAll"></label>
              </th>
              <th
                v-for="(value, key) in dhcpOption82PortConfig.title"
                :key="key"
                :title="value"
                :style="{
                  width: key === 'port' || key === 'switch'? '10%' : 'auto',
                }"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in dhcpOption82PortConfig.data"
              :key="row.port"
              :class="{ 'true:': true }"
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectPort' + index"
                  />
                  <label :for="'idRowSelectPort' + index"></label>
                </div>
              </td>
              <td style="width: 10%">
                <div>{{ row.port }}</div>
              </td>
              <td style="width: 10%">
                <div>{{ row.switch }}</div>
              </td>
              <td>
                <div>{{ row.cIdStr }}</div>
              </td>
              <td>
                <div>{{ row.cIdUdStr }}</div>
              </td>
              <td>
                <div>{{ row.rIdStr }}</div>
              </td>
              <td>
                <div>{{ row.rIdUdStr }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowEditTable">
          <dialog-box
            :btitle="'DHCP Option82 Port Config'"
            style="min-height: 100%"
            @close="isShowEditTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-4 control-label" for="switch"
                  >DHCP Option82</label
                >
                <div class="col-sm-6">
                  <select
                    type="text"
                    class="form-control"
                    id="switch"
                    v-model="dhcpOption82PortForm.switch"
                  >
                    <option label="enable" value="enable"></option>
                    <option label="disable" value="disable"></option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label" for="cIdStr"
                  >Circuit ID</label
                >
                <div
                  class="col-sm-6"
                  :class="{
                    'has-error': checkParameters(
                      'cIdStr',
                      dhcpOption82PortForm.cIdStr
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="cIdStr"
                    v-model="dhcpOption82PortForm.cIdStr"
                    placeholder="STRING<1-64>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'cIdStr',
                        dhcpOption82PortForm.cIdStr
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters("cIdStr", dhcpOption82PortForm.cIdStr)
                    }}
                  </small>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label" for="cIdUdStr"
                  >Circuit User-defined</label
                >
                <div
                  class="col-sm-6"
                  :class="{
                    'has-error': checkParameters(
                      'cIdUdStr',
                      dhcpOption82PortForm.cIdUdStr
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="cIdUdStr"
                    v-model="dhcpOption82PortForm.cIdUdStr"
                    placeholder="STRING<1-128>"
                    autocomplete="off"
                    :title="cIdUdStrTitle"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'cIdUdStr',
                        dhcpOption82PortForm.cIdUdStr
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters("cIdUdStr", dhcpOption82PortForm.cIdUdStr)
                    }}
                  </small>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label" for="rIdStr"
                  >Remote ID</label
                >
                <div
                  class="col-sm-6"
                  :class="{
                    'has-error': checkParameters(
                      'rIdStr',
                      dhcpOption82PortForm.rIdStr
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="rIdStr"
                    v-model="dhcpOption82PortForm.rIdStr"
                    placeholder="STRING<1-64>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'rIdStr',
                        dhcpOption82PortForm.rIdStr
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters("rIdStr", dhcpOption82PortForm.rIdStr)
                    }}
                  </small>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label" for="rIdUdStr"
                  >Remote User-defined</label
                >
                <div
                  class="col-sm-6"
                  :class="{
                    'has-error': checkParameters(
                      'rIdUdStr',
                      dhcpOption82PortForm.rIdUdStr
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="rIdUdStr"
                    v-model="dhcpOption82PortForm.rIdUdStr"
                    placeholder="STRING<1-128>"
                    autocomplete="off"
                    :title="rIdUdStrTitle"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'rIdUdStr',
                        dhcpOption82PortForm.rIdUdStr
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters("rIdUdStr", dhcpOption82PortForm.rIdUdStr)
                    }}
                  </small>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "dhcpOption82Port",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      dhcpOption82PortConfig: "",
      isShowEditTable: false,
      isSelectAll: false,
      iBox: {},
      portIsPon: false,
      dhcpOption82PortForm: {
        switch: "",
        cIdStr: "" /* circuit-id string */,
        cIdUdStr: "" /* circuit-id user-defined format string */,
        rIdStr: "" /* remote-id string */,
        rIdUdStr: "" /* remote-id user-defined format string */,
      },
      /* Circuit ID User-defined Format String Title */
      cIdUdStrTitle:
        "format string, use keywords and delimiters to define. Keywords include:\
\r\nsysip, sysname, portname, iftype, mac, frame, slot, subslot, port, svlan, cvlan, clientmac,\
\r\nipvlan[VLAN ID], ontid, ontport, ontsn, gemport. A valid example: %sysip %portname:%svlan.%cvlan",
      /* Remote ID User-defined Format String Title */
      rIdUdStrTitle:
        "format string, use keywords and delimiters to define. Keywords include:\
\r\nsysip, sysname, portname, iftype, mac, frame, slot, subslot, port, svlan, cvlan, clientmac,\
\r\nipvlan[VLAN ID], ontid, ontport, ontsn, gemport. A valid example: %sysip %portname:%svlan.%cvlan",
    }
  },

  created() {
    this.loadDhcpOption82PortConfig()
  },

  methods: {
    loadDhcpOption82PortConfig() {
      get("dhcpOption82PortConfig")
        .then((res) => (this.dhcpOption82PortConfig = res.data))
        .catch((err) => {
          this.dhcpOption82PortConfig = en.dhcpOption82PortConfig
        })
    },
    clkEdit() {
      for (let i = 0; i < this.dhcpOption82PortConfig.data.length; i++) {
        if (this.dhcpOption82PortConfig.data[i].selected == true) {
          if (this.dhcpOption82PortConfig.data[i].port[0] == "g") {
            this.portIsPon = true
            this.cIdUdStrTitle =
              "format string, use keywords and delimiters to define. Keywords include:\
\r\nsysip, sysname, portname, iftype, mac, frame, slot, subslot, port, svlan, cvlan, clientmac,\
\r\nipvlan[VLAN ID], ontid, ontport, ontsn, gemport. A valid example: %sysip %portname:%svlan.%cvlan"
            this.rIdUdStrTitle =
              "format string, use keywords and delimiters to define. Keywords include:\
\r\nsysip, sysname, portname, iftype, mac, frame, slot, subslot, port, svlan, cvlan, clientmac,\
\r\nipvlan[VLAN ID], ontid, ontport, ontsn, gemport. A valid example: %sysip %portname:%svlan.%cvlan"
          } else {
            this.portIsPon = false
            this.cIdUdStrTitle =
              "format string, use keywords and delimiters to define. Keywords include:\
\r\nsysip, sysname, portname, iftype, mac, frame, slot, subslot, port, svlan, cvlan, clientmac,\
\r\nipvlan[VLAN ID]. A valid example: %sysip %portname:%svlan.%cvlan"
            this.rIdUdStrTitle =
              "format string, use keywords and delimiters to define. Keywords include:\
\r\nsysip, sysname, portname, iftype, mac, frame, slot, subslot, port, svlan, cvlan, clientmac,\
\r\nipvlan[VLAN ID]. A valid example: %sysip %portname:%svlan.%cvlan"
          }

          this.dhcpOption82PortForm.switch =
            this.dhcpOption82PortConfig.data[i].switch
          this.dhcpOption82PortForm.cIdStr =
            this.dhcpOption82PortConfig.data[i].cIdStr
          this.dhcpOption82PortForm.cIdUdStr =
            this.dhcpOption82PortConfig.data[i].cIdUdStr
          this.dhcpOption82PortForm.rIdStr =
            this.dhcpOption82PortConfig.data[i].rIdStr
          this.dhcpOption82PortForm.rIdUdStr =
            this.dhcpOption82PortConfig.data[i].rIdUdStr

          this.isShowEditTable = true
          return
        }
      }
    },
    clkCancel() {
      this.isShowEditTable = false
    },
    changeSelectAll() {
      for (let i = 0; i < this.dhcpOption82PortConfig.data.length; i++) {
        if (this.isSelectAll) {
          this.dhcpOption82PortConfig.data[i].selected = true
        } else {
          this.dhcpOption82PortConfig.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.dhcpOption82PortConfig.data.length; i++) {
        this.dhcpOption82PortConfig.data[i].selected = false
      }
      this.isSelectAll = false
    },
    clkApply() {
      var dhcpOption82PortConfig = {
        switch: this.dhcpOption82PortForm.switch,
        cIdStr: this.dhcpOption82PortForm.cIdStr,
        cIdUdStr: this.dhcpOption82PortForm.cIdUdStr,
        rIdStr: this.dhcpOption82PortForm.rIdStr,
        rIdUdStr: this.dhcpOption82PortForm.rIdUdStr,
        portList: [],
      }

      /* parameters检查 */
      if (this.checkParameters("cIdStr", this.dhcpOption82PortForm.cIdStr)) {
        this.showAlertBox("warn", "Message", "Invalid circuit-id string")
        return
      } else if (this.checkParameters("cIdUdStr", this.dhcpOption82PortForm.cIdUdStr)) {
        this.showAlertBox("warn", "Message", "Invalid circuit-id user-defined format string")
        return
      } else if (this.checkParameters("rIdStr", this.dhcpOption82PortForm.rIdStr)) {
        this.showAlertBox("warn", "Message", "Invalid remote-id string")
        return
      } else if (this.checkParameters("rIdUdStr", this.dhcpOption82PortForm.rIdUdStr)) {
        this.showAlertBox("warn", "Message", "Invalid remote-id user-defined format string")
        return
      }

      for (let i = 0; i < this.dhcpOption82PortConfig.data.length; i++) {
        if (this.dhcpOption82PortConfig.data[i].selected) {
          dhcpOption82PortConfig.portList.push({
            port: this.dhcpOption82PortConfig.data[i].port,
          })
          //this.test_modify_option82Port(dhcpOption82PortConfig, i)
          /* 讨论目前一次配置一个端口 */
          //break
        }
      }

      post("dhcpOption82PortConfig", dhcpOption82PortConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadDhcpOption82PortConfig()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowEditTable = false
      console.log("****isShowEditTable")
      console.log(this.isShowEditTable)
      this.selectNull()
    },
    test_modify_option82Port(tmp, port) {
      this.dhcpOption82PortConfig.data[port].switch = tmp.switch
      this.dhcpOption82PortConfig.data[port].cIdStr = tmp.cIdStr
      this.dhcpOption82PortConfig.data[port].cIdUdStr = tmp.cIdUdStr
      this.dhcpOption82PortConfig.data[port].rIdStr = tmp.rIdStr
      this.dhcpOption82PortConfig.data[port].rIdUdStr = tmp.rIdUdStr
      console.log("****dhcpOption82PortConfig")
      console.log(this.dhcpOption82PortConfig.data[port])
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
    /* 输入参数检测 */
    checkParameters(type, value) {
      if (value === "") {
        return null
      }

      if (type == "cIdStr" || type == "rIdStr" || type == "cIdUdStr" || type == "rIdUdStr") {
        if (nonASCIIchar(value)) {
          return "Contains Chinese characters."
        } else if (value.split(" ").length > 1) {
          return "Contains Spaces."
        } 
      }

      if (type == "cIdStr" || type == "rIdStr") {
        if (value.length > 64) {
          return "String overlength."
        }
      }

      if (type == "cIdUdStr" || type == "rIdUdStr") {
        if (value.length > 128) {
          return "String overlength."
        }
      }

      return null
    },
  },
}
</script>
